require("./legend");

require("./legend/ScrollableLegendModel");

require("./legend/ScrollableLegendView");

require("./legend/scrollableLegendAction");


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/legendScroll.js
// module id = 958
// module chunks = 0